import './FileUploadView.styles.css';
import dayjs from 'dayjs';
import classnames from 'classnames';
import type { FileUploadViewProps } from './FileUploadView.types';
import { DATE_FORMAT } from '../../constants/app.ts';
import { getFileExtension } from './helpers/getFileExtension';
import { getFileIcon } from './helpers/getFileIcon';
import { getFileSize } from './helpers/getFileSize';
import ConfirmDeleteButton from '../confirm-delete-button/ConfirmDeleteButton.tsx';
import i18n from '../../utils/i18n.ts';

const FileUploadView = ({ file, onDelete, showDelete = false }: FileUploadViewProps) => {
  const handleDelete = () => {
    if (onDelete) onDelete((file.uid || file.sharePointItemId) ?? 'unknown');
  };
  return (
    <div className={classnames('file-upload-view-container', { 'view-only': !showDelete })}>
      <div className="file-upload-view-left">
        <div className="file-upload-view-icon">
          {getFileIcon(getFileExtension(file?.name || file?.fileName))}
        </div>
        <div className="file-upload-view-content">
          <div className="file-upload-view-title">{file.name || file?.fileName}</div>
          <div className="file-upload-view-info">
            <span>{getFileSize(file.size)}</span>
            <span> | </span>
            <span>{dayjs(file.createdAt).format(DATE_FORMAT)}</span>
          </div>
        </div>
      </div>
      {showDelete && (
        <div className="file-upload-view-right">
          <ConfirmDeleteButton
            isIconButton
            onSubmit={handleDelete}
            title={i18n.t('common.document')}
          />
        </div>
      )}
    </div>
  );
};

export default FileUploadView;